import type { TypeMappingSEOOutput } from '@shared/api/middleware/mappingAPI/seo/type'

export type ListingSeoIntroView = {
  title: string | null
  description: string | null
}

/**
 * @function buildListingSeoIntroView
 * @description view-model intro листинга из seo_read для server/client слоёв
 */
export const buildListingSeoIntroView = (seo_read: TypeMappingSEOOutput | null | undefined): ListingSeoIntroView => ({
  title: seo_read?.request?.trim() || null,
  description: seo_read?.description?.trim() || null,
})

/**
 * @function shouldOverrideListingSeoIntroWithRedux
 * @description client intro только когда redux отличается от server initial
 */
export const shouldOverrideListingSeoIntroWithRedux = (
  redux: ListingSeoIntroView,
  initialIntroView: ListingSeoIntroView,
): boolean => {
  const titleChanged = Boolean(redux.title && redux.title !== initialIntroView.title)
  const descriptionChanged = Boolean(redux.description && redux.description !== initialIntroView.description)
  return titleChanged || descriptionChanged
}
